import { Injectable } from '@angular/core';
import { Subject, ReplaySubject, BehaviorSubject } from 'rxjs';
import { ListingCategory, MyRemaxModes, LoginSource } from '../classes/enums';
import { SavedSearch } from '../classes/saved-search';
import { Listing } from '../classes/listing';
import { SearchFiltersParams } from '../classes/search-filters-params';
import {ResizeService} from './resize/resize.service';
import { MapUpdate } from '../classes/interfaces';
import { RouteCode } from '../classes/route-code';

@Injectable()
export class CommunicationService {
  constructor(private resizeService: ResizeService) {
  }

  showSignIn = new Subject<boolean | LoginSource>();
  searchParametersChanged = new Subject<void>();
  searchResultsAvailable = new BehaviorSubject<number>(0);
  flipPage = new Subject();

  selectedSaveSearch = new BehaviorSubject<SavedSearch>(null);
  activeRouteCode = new BehaviorSubject<RouteCode>(null);

  activeMyRemaxMode = new BehaviorSubject<MyRemaxModes>(MyRemaxModes.FAVOURITES); // Whether they're on the favourites or saved searches tab
  toolbar = {
    filtersRequested: new Subject(),
    saveSearchRequested: new Subject(),
    searchFilters: new Subject()
  };
  searching = {
    activeSearchText: new BehaviorSubject(''),
    updateMap: new BehaviorSubject<MapUpdate>(null),
    // If this is set to false, on the home-page, we won't set the map to the user's location
    shouldCenterAtUserLocation: new BehaviorSubject<boolean>(true)
  };
  notifications = {
    notificationChanged: new Subject<string>(),
    bottomNotification: new Subject<string>(),
    // TODO: don't like this, should maybe change into just the modal message instead
    enableNotifications: new BehaviorSubject<boolean>(false),
    showQuebecModal: new Subject<boolean>()
  };
  navigation = {
    toggleNavs: new BehaviorSubject<{ left: boolean, right: boolean }>({ left: false, right: false }),
    showSearch: new BehaviorSubject<boolean>(false)
  };
  screenSize = new BehaviorSubject(this.resizeService.getMediaQuerySize());
  listings = {
    listingsClicked: new Subject<Array<Listing>>(),
    previousShownListingType: null, // Whether we're showing residential, commercial or luxury listings
    currentShownListingType: new BehaviorSubject<ListingCategory>(ListingCategory.RESIDENTIAL), // Whether we're showing residential, commercial or luxury listings
    listingCategory: new BehaviorSubject<ListingCategory>(ListingCategory.RESIDENTIAL), // TODO: can we squeeze this in with the above
    isEdmontonBoard: new BehaviorSubject<string>(null) // MBL-3171 - Need to get listing Source
  };
  map = {
    highlightMarker: new Subject<{ action: string, listingId: string }>()
  };
  gallery = {
    expand: new BehaviorSubject<boolean>(false)
  };
  filters = {
    search: new Subject<SearchFiltersParams>(),
    totalHits: new BehaviorSubject(0),
    resetAndUpdatePropType: new ReplaySubject<string>() // For prop-type pages (on/land-for-sale) and we need to externally trigger a filters reset outside of the filters component and update it to a new value
  };
  savedSearch = {
    showNoSavedSearchFound: new Subject<boolean>()
  };
  footerLinksChange = new Subject<{city: string, province: string}>();

  setCurrentListingType(listingCategory: ListingCategory, resetPrevious = false) {
    this.listings.previousShownListingType = resetPrevious ? null : this.listings.currentShownListingType.value;
    this.listings.currentShownListingType.next(listingCategory);
  }
  backToPreviousListingCategory() {
    if (this.listings.previousShownListingType !== null) {
      this.listings.currentShownListingType.next(this.listings.previousShownListingType);
    }
  }
}
